module.exports = __webpack_public_path__ + "img/btn_domicilio_on.6825308c.png";